import React, { useContext, useMemo } from "react";
import { IPermissionsContextModel, PermissionContextModel } from "./PermissionsContextModel";

let PermissionsContext = new PermissionContextModel();

const PermissionsReactContext = React.createContext<IPermissionsContextModel>(PermissionsContext);

export const PermissionContextProvider: React.FC<{ permissionContext: IPermissionsContextModel } & ReactProps> = ({
  permissionContext,
  children
}) => {
  // eslint-disable-next-line
  const memoizedValue = useMemo(() => permissionContext, [permissionContext.getVersion()]);

  return <PermissionsReactContext.Provider value={memoizedValue}>{children}</PermissionsReactContext.Provider>;
};

export function usePermissionContext() {
  return useContext(PermissionsReactContext);
}

export default PermissionsContext as IPermissionsContextModel;
